import { render, staticRenderFns } from "./ele10.vue?vue&type=template&id=dd90b87e&scoped=true"
import script from "./ele10.vue?vue&type=script&lang=js"
export * from "./ele10.vue?vue&type=script&lang=js"
import style0 from "./ele10.vue?vue&type=style&index=0&id=dd90b87e&prod&lang=scss"
import style1 from "./ele10.vue?vue&type=style&index=1&id=dd90b87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd90b87e",
  null
  
)

export default component.exports